import api from "../../Api/feathers-client";
import { map } from "lodash";

// Call backend service to get assignments which are pending for eveluation
export const getEvaluateAssignmentData = async (userId, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: {          
          $select: ["target","outcome"],
          verb: "attemptAssignment",
          outcome: {
            isEvaluated: "pending",
          },
          site_uuid: site_uuid,
          $distinct: "target",
          $sort: {
            createdAt: -1,
          },
          $limit: -1,
        },
      });
      
      let uniqueAssignmentIds = [...new Set(response.map(item => item.target))];
      // console.log("unique===>",unique);

      let assignments = await api.service("assignments").find({
        query: {
          $select: ["uid", "title", "tasks"],
          uid: uniqueAssignmentIds,
          created_by: userId,
          site_uuid: site_uuid,
          $sort: {
            createdAt: -1,
          },
          $limit: -1,
        },
      });
      //  console.log("assignments=====>",assignments);

      //For asset type add into assignemnt results
      let results = assignments.map((item) => {
        let match = response.find((o) => o.target === item.uid);
        return { ...item, assetType: match ? match.outcome.assetType.value : '' };
      });      

      resolve({
        status: 200,
        message: "Assignment Data",
        data: results,
      });
      
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get assets which are pending for eveluation
export const getEvaluateAssetData = async (assignmentId, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let logsData = await api.service("user-logs").find({
        query: {
          verb: "attemptAssignment",
          outcome: {
            isEvaluated: "pending",
          },
          target: assignmentId,
          site_uuid: site_uuid,
          $distinct: "context",
        },
      });
      logsData = logsData.data;

      let tasks = map(logsData, (o) => {
        if (o.Target && o.Target.taskID) return o.Target.taskID;
      });
      let assets = map(logsData, (o) => {
        if (o.Target && o.Target.assetId) return o.Target.assetId;
      });

      let taskData = await api.service("tasks").find({
        query: {
          $select: ["uid", "title"],
          uid: {
            $in: tasks
          },
        },
      });
      taskData = taskData.data;

      let assetData = await api.service("assets").find({
        query: {
          $select: ["asset_uid", "asset_name"],
          asset_uid: {
            $in: assets
          },
        },
      });
      assetData = assetData.data;

      let assignments = logsData.map((val, index) => {
        let taskObj =  taskData.find((obj)=>{
          return obj.uid === val.Target.taskID
        });

        let assetObj =  assetData.find((obj)=>{
          return obj.asset_uid === val.Target.assetId
        });

        let obj = {};
        obj.assignmetId = assignmentId;
        obj.taskId = taskObj.uid;
        obj.taskName = taskObj.title;
        obj.assetId = assetObj.asset_uid;
        obj.assetName = assetObj.asset_name;
        return obj;
      });
      

      resolve({
        status: 200,
        message: "Assignment Data",
        data: assignments,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get learner which are pending for eveluation
export const getEvaluateLearnerData = async (assetId, taskId, assignmentId, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: {
          $select:['actor'],
          verb: "attemptAssignment",
          outcome: {
            isEvaluated: "pending",
          },
          site_uuid: site_uuid,
          context: {
            'taskID': taskId,
            'assetId': assetId
          },
          target: assignmentId,
          $sort: {
            createdAt: -1,
          },
          $limit: -1,
        },
      });
      
      let usersList = map(response,'actor');

      let users = await api.service("users").find({
        query: {
          $select: ["uid","name", "belongs_to"],
          site_uuid: site_uuid,
          status: true,
          uid: usersList
        },
      });

      resolve({
        status: 200,
        message: "Assignment Data",
        data: users.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get learner log data which are pending for eveluation
export const getEvaluateLogData = async (assetId, taskId, assignmentId, actorId, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let log = await api.service("user-logs").find({
        query: {
          actor: actorId,
          verb: "attemptAssignment",
          outcome: {
            isEvaluated: "pending",
          },
          site_uuid: site_uuid,
          context: {
            'taskID': taskId,
            'assetId': assetId
          },
          target: assignmentId,
          $sort: {
            createdAt: -1,
          },
          $limit: 1,
        },
      });
      

      resolve({
        status: 200,
        message: "Assignment Data",
        data: log.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to update evaluation result in user-logs
export const updateLog = async (outcome, site_uuid, uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").patch(
        null,
        {
          outcome
        },
        {
          query: {
            site_uuid,
            uid,
          },
        }
      );

      console.log("response", response);
      if (response.length == 0) {
        resolve({
          status: 404,
          message: "Not found",
        });
      }
      resolve({
        status: 200,
        message: "Score updated successfully.",
      });
    } catch (error) {
      resolve({
        status: 500,
        message: error.message,
      });
    }
  });
};